module.exports = __webpack_public_path__ + "static/media/frame3.f3030045.svg";